import { render } from "./SegregationPlanTable.vue?vue&type=template&id=d43686ea&ts=true"
import script from "./SegregationPlanTable.vue?vue&type=script&lang=ts"
export * from "./SegregationPlanTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__